module.exports = __webpack_public_path__ + "img/3x.189ec63.jpg";